import { useContext } from 'react';

import { ExpandableErrorAlert } from '@/components/ExpandableErrorAlert';
import { Text } from '@/design-system';

import { StateContext } from '../../../control/state';

export const GraphTraceErrorAlert = () => {
  const { runState, updates } = useContext(StateContext);

  if (runState.type !== 'error' || updates.length) return null;

  const errorMessage =
    typeof runState.error === 'string'
      ? runState.error
      : typeof runState.error === 'object' &&
        runState.error !== null &&
        'message' in runState.error
      ? (runState.error.message as string)
      : 'Error running graph';
  return (
    <div className="flex flex-col gap-2 border-t border-secondary p-2">
      <Text variant="md" weight="semibold" className="text-error">
        Error running graph
      </Text>
      <ExpandableErrorAlert error={errorMessage} />
    </div>
  );
};
